/*
 * @Author: taoyuan taoyuan@originqc.com
 * @Date: 2023-03-02 11:23:09
 * @LastEditors: taoyuan taoyuan@originqc.com
 * @LastEditTime: 2024-04-16 10:54:20
 * @FilePath: \qcloud-web-pc-4.0\src\api\index.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import type {
  GetUserInfoData,
  AxiosData,
  IAppListType,
  GetAppData,
  AccountObj,
  IAppApplyParamsType,
  IQappApplyDataType,
  GetResourceData,
  GetUserInfoDecData,
  crytoType
} from './type';
import request from '@/plugins/services/request';
import { apiPrefix } from '@/api/config';

export * from './feeCenter';
export * from './type';
export * from './resource';
export * from './instanceCenter';

/**
 * @description: 获取用户信息 示例
 * @param {*} Promise
 * @param {*} any
 * @return {*}
 */
export const getUserInfo = (): GetUserInfoData =>
  request({
    url: 'uc/userInfo/getUserInfo.json',
  });


  export const encryUserInfo = (data:crytoType): GetUserInfoDecData =>
  request({
    url: 'uc/userInfo/userInfo.json',
    method: 'post',
    data,
  });

/**
 * @description: 获取头部导航的菜单配置
 * @returns
 */
export const getMenuList = (): AxiosData => {
  return request.get(`/${apiPrefix}/headMenu/menuList.json`);
};

/**
 * @description: 获取工作台应用界面的应用列表
 */
export const getaAppCenterList = (params?: IAppListType): GetAppData => {
  return request.post(`/${apiPrefix}/apCenter/apCenterList.json`, params);
};

// 获取账号信息
export const getAccountInfo = (): AxiosData<AccountObj> =>
  request({
    url: `/${apiPrefix}/feeCenter/getAccount.json`,
  });
export const qappApply = (params: IAppApplyParamsType):IQappApplyDataType => {
  return request.post(`/${apiPrefix}/qappApply/apply`, params)
}
export const qappSendCode = (tel:string):AxiosData => {
  return request.post(`/${apiPrefix}/qappApply/sendCode`, {tel})
}


//获取计算服务资源
export const getResourceInfo = (): GetResourceData =>
request({
  url: `${apiPrefix}/taskApi/getCalculateResource.json`,
});